import React, { useState, useEffect } from "react";
import AlertBanner from "canvas-core-react/lib/AlertBanner";
import PrimaryButton from "canvas-core-react/lib/PrimaryButton";
import SecondaryButton from "canvas-core-react/lib/SecondaryButton";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import CustomCheckbox from "../../../shared/custom-components/checkbox";
import CustomSelect from "../../../shared/custom-components/customSelect";
import CustomInput from "../../../shared/custom-components/customInput";
import Modal from "../../../utils/customModal";
import useApi from "../../../hooks/useApi";
import useForm from "../../../hooks/useForm";
import { errorContainer, loadingHtml } from "../../../utils/functions";

const SpecialConditionEdit = ({ companyId, code }) => {
  const [state, setState] = useState({
    hasExtensionTerm: false,
    days: "",
    numbersApproval: 0,
  });

  const [range, setRange] = useState({ min: 0, max: 0 });
  const [modal, setModal] = useState(defaultModal);
  const [showAlert, setShowAlert] = useState(false);

  const { getApiCAll, postApiCAll } = useApi();
  const history = useHistory();
  const { t } = useTranslation();

  const { labels, buttonsLabel } = {
    labels: t("clients.profile.specialCodition", { returnObjects: true }),
    buttonsLabel: t("general.buttons", { returnObjects: true }),
  };

  const goBack = () => history.push(`/bscadministrator/home`);

  const callback = async (data) => {
    try {
      setModal({ content: loadingHtml(), show: true });
      await postApiCAll(`/companies/extension-term/${companyId}`, data);
      setShowAlert(true);
      resetModal();
    } catch (err) {
      setModal({
        show: true,
        content: errorContainer(
          labels.errorRegister,
          err.response.data?.notifications[0].description,
          {
            continueBtn: { text: buttonsLabel.accept, action: resetModal },
          }
        ),
      });
    }
  };

  const { values, errors, handleChange, onSubmit, setValue } = useForm({
    initialState: state,
    validation: {
      days: {
        isBetween: {
          msg: t("general.formErrors.between", range),
          parameters: range,
        },
      },
    },
    callback,
  });

  const getInitialData = async () => {
    try {
      setModal({ show: true, content: loadingHtml() });
      const [
        {
          data: { data: termData },
        },
        {
          data: {
            data: { content },
          },
        },
      ] = await Promise.all([
        getApiCAll(`/companies/extension-term/${companyId}`),
        getApiCAll(`/parameters/plazos/${code}`),
      ]);
      setState({
        hasExtensionTerm: termData.hasExtensionTerm,
        days: termData.days,
        numbersApproval: termData.numbersApproval,
      });
      setRange({ min: +content[0].value, max: +content[1].value });
      resetModal();
    } catch (err) {
      const { message, description } = err.response.data?.notifications[0];
      setModal({
        content: errorContainer(message, description, {
          cancelBtn: { text: buttonsLabel.close, action: resetModal },
        }),
      });
    }
  };

  const resetModal = () => setModal(defaultModal);

  useEffect(() => {
    getInitialData();
  }, []);

  return (
    <>
      <div className="special-contidions-container-tab">
        <CustomCheckbox
          className={"special-contidions-checkbox mb-4 mt-5"}
          label={labels.checkbox}
          checked={values.hasExtensionTerm}
          onChange={(e) => setValue("hasExtensionTerm", e.target.checked)}
          error={Object.keys(errors).length > 0}
        />

        {values.hasExtensionTerm && (
          <>
            <div className="d-flex">
              <CustomInput
                className="special-contidions-input"
                label={`${labels.term}:`}
                name="days"
                value={values.days}
                onChange={handleChange}
                onlyNumber
                error={errors.days}
              />
              <p className="ml-3 mt-3"> {labels.days}</p>
            </div>
            <CustomSelect
              className="special-contidions-select-fix"
              label={`${labels.approvers}:`}
              items={items}
              name="numbersApproval"
              value={values.numbersApproval}
              onChange={handleChange}
            />
          </>
        )}
      </div>

      <div className="form-actions clearfix">
        {showAlert && (
          <AlertBanner
            type="success"
            className="special-contidions-container-tab my-5"
          >
            <>{labels.successfulRegister}</>
          </AlertBanner>
        )}
        <SecondaryButton onClick={goBack}>{buttonsLabel.back}</SecondaryButton>
        <PrimaryButton onClick={onSubmit}>{buttonsLabel.save}</PrimaryButton>
      </div>
      <Modal show={modal.show}> {modal.content}</Modal>
    </>
  );
};

export default SpecialConditionEdit;

const items = [...Array(4).keys()].map((item) => ({
  label: item,
  value: item,
}));

const defaultModal = { show: false, content: null };
